import RolesAndPermisionsPage from './lib/pages/RolesAndPermisionsPage';

export * from './lib/index';

export { RolesAndPermisionsPage };
